// src/is-html-element.ts
function isHTMLElement(value) {
  return typeof value === "object" && value?.nodeType === Node.ELEMENT_NODE && typeof value?.nodeName === "string";
}

export {
  isHTMLElement
};
